const variable = {
  primaryColor: '#067ab4',
  primaryColorHighlight: 'rgba(6, 122, 180, 0.4)',
  primaryColorHighlightSolid: 'rgb(155, 202, 225)',
  callBtnColor: '#5fb95c',
  smsBubbleBackgroundColor: '#d5f3fd',
  brandFontColor: '#067ab4',
  brandFontColorHighlight: 'rgba(6, 122, 180, 0.4)',

  c2dArrowColor: '#ffffff',
  addMeetingBtnColor: '#067ab4',
  addMeetingBtnTextColor: '#FFFFFF',
};

export default variable;
